export default __webpack_public_path__ + "static/media/unknown.825cd492.svg";